import { LabelType, Options } from '@angular-slider/ngx-slider';
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BlockTimesProximityActions } from './state/block-times-proximity.actions';

@Component({
    selector: 'block-times-proximity',
    templateUrl: './block-times-proximity.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BlockTimesProximityComponent implements OnInit {
    blockTimes = [];
    blockTimesJson = [];
    pipe = new DatePipe('en-US');
    proximity = 0;
    blockedTypeForDateAndDay = [{label: 'Closed', value: 'Closed'},
                                {label: 'Range', value: 'Range'}, {label: 'Delete', value: 'Delete'}];
    blockedType = [{label: 'Open', value: 'Open'}, {label: 'Closed', value: 'Closed'},
                   {label: 'Range', value: 'Range'}];

    options: Options = {
        floor: 0,
        ceil: 1440,
        step: 15,
        showTicks: true,
        noSwitching: true,
        // bestFirstLast: 1200,
        translate: (value: number, label: LabelType): string =>
            this.convertNumberToTime(value)
    };

    convertNumberToTime(decimal: number): string {
        let running;
        let hours;
        let minutes;
        let amPm = 'AM';

        running = decimal / 60;
        hours = Math.floor(running);
        running = running - hours;
        minutes = Math.round(running * 60);

        amPm = Number(hours) < 12 ||  Number(hours) === 24 ? 'AM' : 'PM';
        if (hours === 0) {
            hours = 12;
        }
        if (hours === 24) {
            hours = 12;
        }
        hours = Number(hours) <= 12 ? hours : hours - 12;
        if (hours.toString().length === 1) {
            hours = `0${hours}`;
        }
        if (minutes.toString().length === 1) {
            minutes = `0${minutes}`;
        }

        return `${hours}:${minutes} ${amPm}`;
    }

    constructor(private previewBsModalRef: BsModalRef,
                private store: Store<any>,
                private modalService: BsModalService) {}

    public onCancel(): void {
        const config: any = {...this.modalService.config.initialState};
        this.store.dispatch(BlockTimesProximityActions
            .updateBlockTimeAndProximity({blockTimes: config.blockTimes, proximity: config.proximity, isCancelled: true}));
        this.previewBsModalRef.hide();
    }

    public saveChanges(): void {
       const normalizedProximity = this.normalizeProximity(this.proximity);

       this.store.dispatch(BlockTimesProximityActions
            .updateBlockTimeAndProximity({blockTimes: this.getBlockTimesJson(), proximity: normalizedProximity, isCancelled: false}));
       this.previewBsModalRef.hide();
    }

    normalizeProximity(value: number): number {
      if (value < -1) {
         return 0;
      }

      if (value > 1440) {
         return 1440;
      }

      return value;
   }
    addDate(): void {
        this.blockTimes.push({isDefault: false, isDay: false, isDate: true, range: [680, 1200], value: new Date(), type:  'Closed' });
    }

    addDay(): void {
        this.blockTimes.push({isDefault: false, isDay: true, isDate: false, range: [680, 1200], value: new Date(), type:  'Closed' });
    }

    ngOnInit(): void {
        this.blockTimes = [];
        this.blockTimesJson = [];
        this.setDefaultAndWeekdays();
        const config: any = {...this.modalService.config.initialState};
        this.proximity = config.proximity;
        if (Object.keys(config.blockTimes).length !== 0) {
            this.setBlockTimes(config.blockTimes);
        }
    }

    dateToggle(datePicker): any {
        datePicker.toggle();
    }

    getBlockTimesJson(): any {
        this.blockTimesJson = [];
        this.blockTimes.forEach(blockTime => {
            if (blockTime.isDefault) {
                this.blockTimesJson.push({start: blockTime.range[0], stop: blockTime.range[1]});
            } else if (blockTime.isDate) {
                    if (blockTime.type === 'Closed') {
                        this.blockTimesJson.push({date: this.pipe.transform(blockTime.value, 'yyyy-MM-dd')});
                    } else {
                        this.blockTimesJson
                            .push({date: this.pipe.transform(blockTime.value, 'yyyy-MM-dd'),
                                   start: +blockTime.range[0], stop: +blockTime.range[1]});
                    }
            } else if (blockTime.isDay) {
                if (blockTime.type === 'Closed') {
                    this.blockTimesJson.push({day: this.pipe.transform(blockTime.value, 'MM-dd')});
                } else {
                    this.blockTimesJson
                        .push({day: this.pipe.transform(blockTime.value, 'MM-dd'),
                               start: +blockTime.range[0], stop: +blockTime.range[1]});
                }
            } else {
                if (blockTime.type !== 'Open') {
                    if (blockTime.type === 'Closed') {
                        this.blockTimesJson.push({weekday: blockTime.value});
                    } else {
                        this.blockTimesJson
                            .push({weekday: blockTime.value,
                                   start: +blockTime.range[0], stop: +blockTime.range[1]});
                    }

                }
            }
        });

        return this.blockTimesJson;
    }

    onChange(event, selectedBlockTime): void {
        const index = this.blockTimes.findIndex(blocktime => blocktime === selectedBlockTime);
        switch (event.value) {
            case 'Range':
                this.blockTimes[index].range = selectedBlockTime.range;
                break;
            case 'Delete':
                this.blockTimes.splice(index, 1);
                break;
            default:
                console.log('hi' , event.value);
        }
    }

    setBlockTimes(blockTimes): void {
        blockTimes.forEach(selectedBlockTime => {
            let range = [0, 1440];
            let type = 'Closed';
            if (selectedBlockTime.start !== undefined) {
                range = [+selectedBlockTime.start, +selectedBlockTime.stop];
                type = 'Range';
            }
            if (selectedBlockTime['weekday'] === undefined
                && selectedBlockTime['date'] === undefined
                && selectedBlockTime['day'] === undefined) {
                this.blockTimes[0].range = range;
            } else if (selectedBlockTime['weekday'] !== undefined) {
                const index = this.blockTimes.findIndex(weekday => weekday.value === selectedBlockTime['weekday']);
                this.blockTimes[index].range = range;
                this.blockTimes[index].type = type;
            } else if (selectedBlockTime['date'] !== undefined) {
                this.blockTimes.push({isDefault: false, isDay: false, isDate: true, range,
                                      value: new Date(selectedBlockTime['date']), type });
            } else if (selectedBlockTime['day'] !== undefined) {
                this.blockTimes.push({isDefault: false, isDay: true, isDate: false, range,
                                      value: new Date(selectedBlockTime['day']), type });
            }

        });

    }

    setDefaultAndWeekdays(): void {
        this.blockTimes.push({label: 'Default', isDefault: true, isDay: false, isDate: false, range: [480, 1200], type: 'Range' });
        this.blockTimes.push({label: 'Monday', value: 1, isDefault: false, isDay: false, isDate: false, range: [480, 1200], type: 'Open' });
        this.blockTimes.push({label: 'Tuesday', value: 2, isDefault: false,
                              isDay: false, isDate: false, range: [480, 1200], type: 'Open' });
        this.blockTimes.push({label: 'Wednesday', value: 3, isDefault: false,
                              isDay: false, isDate: false, range: [480, 1200], type: 'Open' });
        this.blockTimes.push({label: 'Thursday', value: 4, isDefault: false,
                              isDay: false, isDate: false, range: [480, 1200], type: 'Open' });
        this.blockTimes.push({label: 'Friday', value: 5, isDefault: false,
                              isDay: false, isDate: false, range: [480, 1200], type:  'Open' });
        this.blockTimes.push({label: 'Saturday', value: 6, isDefault: false,
                              isDay: false, isDate: false, range: [480, 1200], type: 'Open' });
        this.blockTimes.push({label: 'Sunday', value: 7, isDefault: false,
                              isDay: false, isDate: false, range: [480, 1200], type:  'Open' });
    }

    isValid(): boolean {
        return Number(this.proximity) > 1440;
    }
}
